import { OnOrder } from 'services/api/pay';
import type { OrderInfo } from './components/PayModal';
import { logPricing } from './pricingLogger';

interface HandleOrderDependencies {
  orderAndPay: OnOrder;
  showPayModal: (info: OrderInfo) => void;
  onError: () => void;
}

export const handleOrder = (
  info: Parameters<OnOrder>[0],
  { orderAndPay, showPayModal, onError }: HandleOrderDependencies,
) => {
  const isSubscription = 'subscription' in info && info.subscription === true;
  const regionPackageId = 'regionPackageId' in info ? info.regionPackageId : undefined;
  const context = {
    requestId: info.idempotent,
    orderAction: info.orderAction,
    packageId: info.packageId,
    regionPackageId,
    currency: info.currency,
    durationNum: 'durationNum' in info ? info.durationNum : undefined,
    accountNum: 'accountNum' in info ? info.accountNum : undefined,
    payType: info.payType,
    subscription: isSubscription,
    quotedPayPrice: info.discountTotalPrice,
  };
  const startedAt = Date.now();
  if (regionPackageId) logPricing('order_requested', context);

  return orderAndPay(info)
    .then((res) => {
      if (regionPackageId) {
        logPricing('order_succeeded', {
          ...context,
          elapsedMs: Date.now() - startedAt,
          orderCode: res?.orderCode,
          hasPaymentUrl: !!res?.paymentUrl,
        });
      }
      // 订阅（连续包月）由订阅弹窗自行处理 Stripe 支付，不打开 PayModal
      if (isSubscription) {
        return res;
      }
      showPayModal({
        ...info,
        ...res,
      });
      return res;
    })
    .catch((error) => {
      if (regionPackageId) {
        logPricing('order_failed', { ...context, elapsedMs: Date.now() - startedAt }, error);
      }
      onError();
      // 订阅流程需要由调用方收尾 loading、轮询和支付弹窗状态。
      if (isSubscription) {
        throw error;
      }
    });
};
